<template>
  <div @click="nextStep" class="modal fade" id="onboarding" role="dialog" aria-hidden="true">
    <div
      :class="`contentPosition${step}`"
      class="modal-dialog modal-dialog-top"
      id="onboarding-modal-dialog"
      role="document">
      <div class="modal-content shadow" >
        <div class="modal-body p-3">
          <div class="loaderContainer">
            <div
              v-for="index in countSteps"
              :key="index"
              :class="{'activeLoaderItem': index - 1 <= step}"
              class="d-flex loaderItem"></div>
          </div>
          <div class="content mt-3 mb-3" v-html="$t(`modals.onboarding_modal.steps[${step}]`)"></div>
          <div>
            <span
              v-if="step < countSteps - 1"
              @click="closeModal"
              class="skip unselectable"
            >
              {{ $t(`modals.onboarding_modal.skip`) }}
            </span>
            <span
              v-if="step < countSteps - 1"
              @click="step++"
              class="text-primary unselectable float-right"
            >
              {{ $t(`modals.onboarding_modal.next`) }}
            </span>
            <span
              v-else
              @click="closeModal"
              class="text-primary unselectable float-right"
            >
              {{ $t(`modals.onboarding_modal.start`) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'OnboardingModal',
    data () {
      return {
        step: 0,
        activeElements: [],
        onboardingModalDialog: {},
        stopSteps: false,
        countSteps: 6,
      };
    },
    computed: {
      ...mapGetters([
        'show_modal_onboarding',
      ]),
    },
    watch: {
      show_modal_onboarding: function () {
        if (this.show_modal_onboarding) {
          if (localStorage.getItem('secondStep') === 'hidden' || localStorage.getItem('firstStep') === 'hidden') { this.countSteps = 6; }
          if (localStorage.getItem('secondStep') === 'hidden' && localStorage.getItem('firstStep') === 'hidden') { this.countSteps = 5; }

          // eslint-disable-next-line no-undef
          $('#onboarding').modal('show');
          document.getElementsByClassName('modal-backdrop')[0].style.backgroundColor = 'rgba(60, 98, 150)';
          document.getElementsByClassName('modal-backdrop')[0].style.zIndex = 1037;

          this.onboardingModalDialog = document.getElementById('onboarding-modal-dialog');
          this.activeElements.push(document.getElementsByClassName('emikaChat')[0]);
          this.activeElements.push(document.getElementsByClassName('emikaChat')[0].getElementsByClassName('card-footer')[0]);

          this.activeElements[0].style.zIndex = 1039;
          this.onboardingModalDialog.style.bottom = '20vh';

          this.$store.commit('hideModal', 'onboarding');
          this.$bus.$emit('preventScroll');
        }
      },
      step: function (newVal) {
        switch (newVal) {
        case 1:
          this.activeElements[0].style.zIndex = 500;
          this.onboardingModalDialog.style.bottom = '';

          if (this.stopSteps) {
            break;
          }

          this.$bus.$emit('scrollToToday');

          this.activeElements[0] = document.getElementById('calendarToday');
          this.activeElements[1] = document.getElementById('calendarTomorrow');

          this.activeElements[0].style.zIndex = 1039;
          this.activeElements[1].style.zIndex = 1039;
          break;
        case 2:
          this.activeElements[0].style.zIndex = 'auto';
          this.activeElements[1].style.zIndex = 'auto';

          if (this.stopSteps) {
            break;
          }

          this.activeElements[0] = document.getElementById('calendarToday').getElementsByClassName('btn-block')[0];

          this.activeElements[0].style.zIndex = 1039;
          this.activeElements[0].style.position = 'sticky';
          this.activeElements[0].style.opacity = '1';
          this.activeElements[0].style.backgroundColor = '#fff';
          this.onboardingModalDialog.style.top = this.activeElements[0].getBoundingClientRect().top + 'px';
          break;
        case 3:
          this.activeElements[0].className = 'btn btn-xs btn-block mt-2 create-task-btn-hide';
          this.activeElements[0].style.zIndex = 'auto';
          this.activeElements[0].style.position = 'auto';
          this.activeElements[0].style.opacity = '0';
          this.activeElements[0].style.backgroundColor = 'inherit';

          if (this.stopSteps) {
            break;
          }

          this.onboardingModalDialog.style.top = '';

          this.activeElements[0] = document.getElementsByClassName('inbox ')[0];
          this.activeElements[1] = document.getElementsByClassName('inbox ')[0].getElementsByClassName('card-header')[0].getElementsByClassName('row')[0];

          this.activeElements[0].style.zIndex = 'auto';

          this.activeElements[1].style.zIndex = 1039;
          this.activeElements[1].style.position = 'sticky';
          this.activeElements[1].style.backgroundColor = '#fff';

          this.onboardingModalDialog.style.bottom = (
            window.innerHeight - this.activeElements[1].getBoundingClientRect().bottom
          ) + 'px';
          break;
        case 4:
          this.activeElements[0].style.zIndex = 500;
          this.activeElements[1].style.zIndex = 'auto';
          this.activeElements[1].style.position = 'auto';

          if (this.stopSteps) {
            break;
          }
          this.activeElements[0].style.zIndex = 'auto';
          this.onboardingModalDialog.style.bottom = '';

          if (localStorage.getItem('firstStep') === 'hidden') {
            this.step++;
          } else {
            this.activeElements[1] = document.getElementById('firstStep');
            this.onboardingModalDialog.style.top = this.activeElements[1].getBoundingClientRect().top + 'px';
            this.activeElements[1].style.zIndex = 1039;
          }
          break;
        case 5:
          this.activeElements[0].style.zIndex = 500;
          this.onboardingModalDialog.style.top = '';
          this.activeElements[1].style.zIndex = 'auto';

          if (this.stopSteps) {
            break;
          }

          this.activeElements[0].style.zIndex = 'auto';
          this.activeElements[1] = document.getElementById('secondStep');
          this.activeElements[1].style.zIndex = 1039;

          this.onboardingModalDialog.style.bottom = (window.innerHeight - this.activeElements[1].getBoundingClientRect().bottom) + 'px';
          break;
        case 6:
          this.activeElements[0].style.zIndex = 500;
          this.activeElements[1].style.zIndex = 'auto';
          break;
        }
      },
    },
    methods: {
      nextStep (event) {
        event.preventDefault();
      },
      closeModal () {
        this.stopSteps = true;
        this.step++;
        // eslint-disable-next-line no-undef
        $('#onboarding').modal('hide');
        this.$bus.$emit('resolveScroll');
        localStorage.setItem('onboarding', 'skip');
      },
    },
  };
</script>

<style scoped>

  .contentPosition0 {
    right: 525px;
  }
  .contentPosition1 {
    left: 1025px;
    top: 40vh;
  }
  .contentPosition2 {
    left: 725px;
  }
  .contentPosition3 {
    left: 425px;
  }
  .contentPosition4 {
    left: 425px;
  }
  .contentPosition5 {
    left: 425px;
  }

  #onboarding {
    z-index: 1038;
  }

  .modal-dialog-top {
    position: fixed;
    width: 337px;
    border-radius: 8px;
  }

  .modal-content {
    border-radius: 8px;
  }
    .loaderContainer {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
      .loaderItem {
        width: 45px;
        height: 4px;
        background: #DDE5F0;
      }
      .activeLoaderItem {
        background-color: #35A666;
      }
  .skip {
    color: #6F85A2;
  }
  .unselectable {
    cursor: pointer;
  }

</style>
